import type { FoodAverageFatInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

export function FoodAverageFat(props: TileProps<FoodAverageFatInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const days = range / 24

  const { foodCalculations } = useCalculationsContext()
  const { totalFat } = foodCalculations[range] || {}

  const value = totalFat === undefined ?
    NaN :
    round(
      totalFat / days,
      1,
    )

  const unit = polyglot.t(
    "unit.grams_day",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
